import clsx from 'clsx';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import { getFormattedTimeFromMinutes } from '../../helpers/time';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';
import styles from './FormAppointment.module.scss';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  types?: string[];
  defaultValues?: any;
}

const days = [
  { label: 'DOM' },
  { label: 'LUN' },
  { label: 'MAR' },
  { label: 'MIE' },
  { label: 'JUE' },
  { label: 'VIE' },
  { label: 'SAB' },
];

function getHours(interval: any) {
  const newInterval = Number(interval);
  const hours = [];

  for (let idx = 360; idx <= 1200; idx = idx + newInterval) {
    hours.push(idx);
  }

  return hours;
}

export default function FormAppointment(props: Props) {
  const { handleSubmit } = useForm({
    defaultValues: replaceDefaultValues(props.defaultValues),
  });
  const meetingInterval = 60;
  const [activeDay, setActiveDay] = useState(0);
  const [activeHours, setActiveHours] = useState<number[][] | undefined>(
    props.defaultValues.availability
  );

  const handleFormSubmit = (data: any) => {
    const activeHoursLen = activeHours?.length ?? 0;
    const newActiveHours: number[][] = [];

    for (let idx = 0; idx < activeHoursLen; idx++) {
      newActiveHours.push(activeHours?.[idx] ? activeHours[idx] : []);
    }

    props.onSubmit({ ...data, meetingInterval, availability: newActiveHours });
  };

  const handleHourClick = (minute: number) => {
    let newDayHours = activeHours?.[activeDay] || [];

    if (newDayHours.includes(minute)) {
      newDayHours = newDayHours.filter((el) => el !== minute);
    } else {
      newDayHours.push(minute);
    }

    const newActiveHours = activeHours ? [...activeHours] : [];
    newActiveHours[activeDay] = newDayHours;

    setActiveHours(newActiveHours);
  };

  const isMinuteIncludedInDay = (minute: number) => {
    return (activeHours?.[activeDay] || []).includes(minute);
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <h1>Crea la agenda de disponibilidad</h1>

      <div className={styles.days}>
        {days.map((day, idx) => (
          <button
            className={clsx(activeDay === idx && styles.isActive)}
            key={idx}
            onClick={() => setActiveDay(idx)}
            type="button"
          >
            {day.label}
          </button>
        ))}
      </div>

      <div className={styles.hours}>
        {getHours(meetingInterval).map((el) => (
          <button
            className={clsx(isMinuteIncludedInDay(el) && styles.isActive)}
            key={el}
            type="button"
            onClick={() => handleHourClick(el)}
          >
            {`${getFormattedTimeFromMinutes(el)}/${getFormattedTimeFromMinutes(
              el + meetingInterval
            )}`}
          </button>
        ))}
      </div>

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
